module.exports = __webpack_public_path__ + "static/tw-mobile-table-bfbe8fe8e8e90d77dad8e2363b7dd217.jpg";